import React from 'react';
import PropTypes from 'prop-types';

const indicator = tooltipText => (
  <div className="with-indicator" data-tip={tooltipText} />
);

const defaultCellRenderer = ({ value }) => value;

const WithIndicatorAndCustomInnerRendererCellRenderer = (customInnerRenderer = defaultCellRenderer) => (
  function WithIndicatorCellRenderer(cellData) {
    const { data, colDef } = cellData;
    const { validationData } = data;
    const tooltipText = validationData && validationData[colDef.field]
      ? validationData[colDef.field].map(error => error.message).join(', ')
      : '';

    return (
      <div>
        {customInnerRenderer(cellData)}
        {tooltipText && indicator(tooltipText)}
      </div>
    );
  }
);

WithIndicatorAndCustomInnerRendererCellRenderer.propTypes = {
  cellData: PropTypes.shape({
    value: PropTypes.shape({
      value: PropTypes.string,
    }),
    data: PropTypes.shape({
      validationData: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.shape({
        message: PropTypes.string,
      }))),
    }),
    colDef: PropTypes.shape({
      field: PropTypes.string,
    }),
  }),
};

export default WithIndicatorAndCustomInnerRendererCellRenderer;
